import { render, staticRenderFns } from "./bill-tab.vue?vue&type=template&id=2c1b175a"
import script from "./bill-tab.vue?vue&type=script&lang=js"
export * from "./bill-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports